module.exports = __webpack_public_path__ + "static/CIW_Part3-717cfef816468dfcff98910a8c5737fd.pdf";